module.exports = __webpack_public_path__ + "img/info.a8381b4.svg";